"use client";
import { blurImage, shimmer, toBase64 } from "@repo/lib/utils";
import Image from "next/image";
import { useEffect, useState } from "react";

const Media = ({
  src,
  alt,
  width = 415,
  height = 415,
  className = "",
  priority,
}) => {
  const fallBackSrc = `data:image/svg+xml;base64,${toBase64(
    blurImage(width, height)
  )}`;
  const [imageSrc, setImageSrc] = useState(src || fallBackSrc);

  useEffect(() => {
    if (src) {
      setImageSrc(src);
    }
  }, [src]);

  return (
    <Image
      alt={alt}
      src={imageSrc}
      width={width}
      height={height}
      placeholder={`data:image/svg+xml;base64,${toBase64(
        shimmer(width, height)
      )}`}
      className={`aspect-square object-contain ${className}`}
      onError={() => setImageSrc(fallBackSrc)}
      {...(priority && { priority: true })}
    />
  );
};

export default Media;
